import React from "react";
import { Container } from "reactstrap";
import { HeaderSection } from "../../components/shared/HeaderSection";

import ROUTES from "../../routes/routes";
import EventCarousel from "../../components/events/EventCarousel";

const Servers = () => {
  const colorEvent = "#00b3bd";

  return (
    <>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver"}
        bgBtnColor={colorEvent}
      />
      <Container>
        <h3 className="subheader-main" style={{ borderColor: colorEvent }}>
          Guia de Eventos
        </h3>
        <section className="carousel-section">
          <EventCarousel />
        </section>
      </Container>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver"}
        bgBtnColor={colorEvent}
      />
    </>
  );
};

export default Servers;
